import { type Href, Redirect } from 'expo-router';
import React from 'react';
import { Platform } from 'react-native';

import { useStorage } from '../../../common/providers/StorageProvider';
import type { ContainerComponent } from '../../../common/types/Common';
import { ModalScreens } from '../../../common/types/Screens';
import { clearRedirectPath, getStoredRedirectPath } from '../../helpers';

const HandleRedirectFromStorage: ContainerComponent = ({ children }) => {
    const storage = useStorage();

    const redirectPath = getStoredRedirectPath(storage, 30); // ignore the redirect path if it's older than 30 minutes

    if (redirectPath !== undefined) {
        clearRedirectPath(storage); // clear after use, as this is meant for one-time use

        // If we need to redirect to a modal route (e.g. from a deep link), we have to handle that in a
        // special way so that the modal screen on native will properly render, stacked "on top of" another
        // screen. Its possible that Expo Router would support this in a simpler way, but it did not work as
        // documented here: https://docs.expo.dev/router/advanced/modals/#handle-deep-linked-modals
        if (
            Platform.OS === 'ios' &&
            Object.values(ModalScreens).some((modalScreenPath) =>
                redirectPath.includes(modalScreenPath),
            )
        ) {
            return (
                <Redirect
                    href={{
                        pathname: '/',
                        params: { goToModalRoute: redirectPath },
                    }}
                />
            );
        }

        // Redirect to the route in local storage, written by RedirectIfNotAuthenticated.
        return <Redirect href={redirectPath as Href} />;
    }

    return <>{children}</>;
};

export default HandleRedirectFromStorage;
